/** The home page's "Quick answers" (home.html, #price), for its FAQ structured data. Keep the
 *  two in step: Google only accepts FAQ markup that matches what the page shows. */
export const HOME_FAQ: ReadonlyArray<{ question: string; answer: string }> = [
  {
    question: 'Is the lead data real?',
    answer: 'Yes: email-verified, high-fit leads before Ali reaches out. Real B2B data filtered to your ICP.',
  },
  {
    question: 'Will outreach sound like spam?',
    answer: 'No. Ali writes Arabic-native and English copy a local would send. You approve before anything goes out.',
  },
  {
    question: 'Is Ali PDPL-aware?',
    answer: 'Yes, by design for Gulf outbound. Full details on our Data Protection page.',
  },
  {
    question: 'Do I lose control?',
    answer: 'No. You approve audience, copy, and send. Ali does the heavy lifting; you keep the final say.',
  },
];
